console.log('Load: [emergency.js]');

import $ from 'jquery';

// Determine host for global4.js (script that includes this module)
function getScriptHost() {
  if (typeof document === 'undefined') return '';

  const scripts = document.getElementsByTagName('script');
  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].getAttribute('src') || '';
    if (src.indexOf('global4.js') !== -1) {
      try {
        const url = new URL(src, window.location.href);
        return url.hostname;
      } catch (e) {
        return '';
      }
    }
  }

  return window.location && window.location.hostname ? window.location.hostname : '';
}

const scriptHost = getScriptHost();

// University emergency feed (Alertus)
// Default: ontariotechu.ca feed; if host is not ontariotechu.ca, use shared.ontariotechu.ca feed
const DEFAULT_EMERGENCY_FEED = 'https://ontariotechu.ca/_inc/emergency/emergency-include.php';
const emergencyFeed = !scriptHost || scriptHost === 'ontariotechu.ca'
  ? DEFAULT_EMERGENCY_FEED
  : 'https://shared.ontariotechu.ca/_inc/emergency/emergency-include.php';
// Alert message bar link
const emergencyLink = 'https://ontariotechu.ca/emergency';

console.log('emergencyFeed:', emergencyFeed);

/**
 * Fetches XML feed
 * @param {string} url URL to fetch
 * @param {function} callback Callback function
 * @param {string} dataType Data type 
 */
function loadXml(url, callback, dataType) {
  $.ajax({
    crossDomain: true,
    cache: true,
    url: url,
    type: 'GET',
    dataType: dataType,
    success: callback,
    error: function (xhr, status, error, url) {
      console.log("Error: Cannot process loadXml() request. Error code = " + xhr.status + " " + xhr.statusText + ". URL: " + url);
    }
  });
}

/**
 * Checks university emergency feed for XML content;
 * if content exists, parses feed for display;
 * if no content exists, checks secondary notification feed for content.
 * @param {data} data XML data 
 */
function parseEmergencyFeed(data) {
  // XML content exists
  if (Object.keys(data).length !== 0) {
    // Format date
    let date = formatDate(data.pubDate);

    // Emergency page content message
    if ($('#emergency-page-message').length) {
      let htmlOutput = '';
      htmlOutput += `<h2 class="header">Emergency Alert</h2>`;
      if (data.title) htmlOutput += `<p class="alert-subheading">${data.title}</p>`;
      if (data.description) htmlOutput += `<p class="alert-description">${data.description}</p>`;
      if (date) htmlOutput += `<p class="alert-date">${date}</p>`;
      $('#emergency-page-message').html(htmlOutput);
      $('#emergency-page-message').addClass('emergency-active');
    }
    // Alert message bar (on all other pages)
    else {
      displayAlertBar("Emergency Alert", data.title, data.description, emergencyLink, date);
    }
  }
  // No XML content exists
  else {
    // On emergency info page: clear message (set to default)
    if ($('#emergency-page-message').length) {
      $('#emergency-page-message').html('<h2>Current status</h2><p>There are no emergencies at Ontario Tech University at this time. Local disruptions affecting the university can be found below.</p>');
      $('#emergency-page-message').removeClass('emergencyPresent');
    }

    // On all pages: remove alert bar
    if ($('#alert-message-bar').length) $('#alert-message-bar').remove();

  }
}

/**
 * Outputs HTML for alert message bar across top of every page
 * @param {string} heading Alert bar heading (required)
 * @param {string} subheading Alert bar subheading (optional)
 * @param {string} content Main content (optional, but recommended)
 * @param {string} link Alert bar link (optional, but recommended)
 * @param {string} date Date (optional)
 */
function displayAlertBar(heading, subheading = '', content = '', link = '', date = '') {
  // Display alert bar
  if (!$('#alert-message-bar').length) {
    let htmlOutput = '';
    htmlOutput += `
		<div id="alert-message-bar" class="header-message-bar">`
    if (link != '') htmlOutput += `<a class="hidden-link" href="${link}"><span class="show-for-sr">${heading}</span></a>`;
    htmlOutput += `
      <div class="header-message-bar-inner"> 
          <div class="header">${heading}</div> 
          <div class="content">`;
    if (subheading != '') htmlOutput += `<p class="alert-subheading">${subheading}</p>`;
    if (content != '') htmlOutput += `<div class="alert-content">${content}</div>`;
    if (date != '') htmlOutput += `<p class="alert-date">${date}</p>`;
    htmlOutput += `
          </div> 
			</div>
		</div>`;

    // Display alert bar before <header>
    $('header').before(htmlOutput);
  }
  // If alert bar is already displayed, just update message
  else {
    $('#alert-message-bar').attr('class', 'header-message-bar ');
    $('#alert-message-bar .alert-heading').text(heading);
    if (link != '') {
      $('#alert-message-bar a').attr('href', link);
      $('#alert-message-bar a .show-for-sr').text(heading);
    }
    if (subheading != '') $('#alert-message-bar .alert-subheading').text(subheading);
    if (content != '') $('#alert-message-bar .alert-content').text(content);
    if (date != '') $('#alert-message-bar .alert-date').text(date);
  }
}

/**
 * Date/time formatting
 * @param {string} date
 */
function formatDate(date) {
  const months = Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");

  let datetime = new Date(date);
  datetime = months[datetime.getMonth()] + ' ' + datetime.getDate() + ', ' + datetime.getFullYear() + ' ' + addZero(datetime.getHours()) + ':' + addZero(datetime.getMinutes());

  return datetime;
}
// Add leading '0' to times in datetime stamp
function addZero(i) {
  if (i < 10) i = "0" + i;
  return i;
}

(function () {
  loadXml(emergencyFeed, parseEmergencyFeed, 'json');
})();

// Check for emergency message every 60 seconds
setInterval(function () {
  loadXml(emergencyFeed, parseEmergencyFeed, 'json')
}, 60000);
